module.exports = __webpack_public_path__ + "static/media/logo-restaurant-placeholder.a9b52b46.svg";


//////////////////
// WEBPACK FOOTER
// /src/lib/images/logo-restaurant-placeholder.svg
// module id = 379
// module chunks = 0